import { closeInlineForms } from "../../../../javascript/stimulusControllers/messages/messageHelpers";

const NEW_MESSAGE_CONTAINER_CLASS = 'new-inline-msg inline-msg-container'

export default class extends Controller {
  static targets = ["button", "list"]

  connect() {
    this.addMessageFormToList = this.addMessageFormToList.bind(this)
    this.appendNewMessage     = this.appendNewMessage.bind(this)
    this.openFormOnLoad && this.openNewMessageForm()
    App.Helpers.listenToCustomEvent(document, "message:new-parent-create-success", this.appendNewMessage)
  }

  openNewMessageForm(event) {
    event && event.preventDefault()
    closeInlineForms(this.element)
    App.Helpers.ajaxRequest({ url: this.newMessageURL, successHandler: this.addMessageFormToList })
  }

  //
  // INTERNAL USE
  //

  addMessageFormToList(response) {
    const el = this.createNewMessageDiv(response)
    App.Helpers.prependContent(this.listTarget, el)
    App.Helpers.addHandlers(el)
    this.buttonTarget.disabled = true
  }

  createNewMessageDiv(html) {
    const el = document.createElement("div")
    el.className= NEW_MESSAGE_CONTAINER_CLASS
    el.innerHTML = html
    return el
  }

  appendNewMessage({ detail }) {
    const { el, newMessage } = detail
    if (el === this.element) {
      App.Helpers.prependContent(this.listTarget, newMessage);
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get newMessageURL() {
    return this.data.get("new-message-url")
  }

  get openFormOnLoad() {
    return ["1", 1, true, "true"].includes(this.data.get("open-form-on-load"))
  }
}



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/messages-messageable-message-feed-controller.js